import React, { useContext, useEffect, useState } from 'react';
import {  Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import { AuthContext } from './../AuthContext';
import './index.css'
export default function Index() {
  const location = useLocation();
  useEffect(() => {
    console.log(location.pathname);
  },[]);
  const { user,fulluser } = useContext(AuthContext);

  
  return (
    <div className="appBottomMenu">
       <Link to="/Main" className={`item  ${(location.pathname == '/Main' && 'active')}`}>
      <div className="col">
      <ion-icon name="home-outline"></ion-icon>
              <strong>Home</strong>
      </div>
    </Link>
        <Link to={user != null ? "/UserActivity" : `/signin`} className={`item  ${(location.pathname == '/UserActivity' && 'active')}`}>
      <div className="col">
        <ion-icon name="card-outline" />
        <strong>My Rewards</strong>
      </div>
    </Link>
   
    <Link to={user != null ? "/Allinv" : `/signin`}  className={`item  ${(location.pathname == '/Allinv' && 'active')}`}>
      <div className="col">
      <ion-icon name="cash-outline"></ion-icon>
              <strong>Shop & Saved</strong>
      </div>
    </Link>
    <Link to={`/AllCate`} className={`item  ${(location.pathname == '/AllCate' && 'active')}`}>
      <div className="col">
      <ion-icon name="apps-outline"></ion-icon>
        <strong>Categories</strong>
      </div>
    </Link>
  
    <Link to={user != null ? "/Payment" : `/signin`} className={`item  ${(location.pathname == '/Payment' && 'active')}`}>
      <div className="col">
      <ion-icon name="card-outline"></ion-icon>
                    <strong>Pay</strong>
      </div>
    </Link>
  </div>
  
  )
}
